export default __webpack_public_path__ + "media/wp.677ef454.png";